import { Component } from '@angular/core';
import { Status } from '@vendasta/sales-orders';
import { SalesOrderTableCustomComponentDirective } from './sales-order-table-custom.component';

@Component({
  selector: 'sales-ui-status-cell',
  template: '{{"FRONTEND.SALES_UI." + getStatusName() | translate}}',
  standalone: false,
})
export class StatusCellComponent extends SalesOrderTableCustomComponentDirective {
  status = Status;

  getStatusName(): string {
    const statusName = this.status[this.element.status];

    if (statusName) {
      return statusName;
    }

    return 'PENDING';
  }
}
